import React, { useEffect, useState } from "react";
import HtmlHead from "../components/html-head/HtmlHead";
import { Link, useNavigate } from "react-router-dom";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import MainService from "../helpers/services/mainService";
import { ApiService } from "../helpers/services/apiSrevice";
import Marquee from "../components/marquee/Marquee";
import useWindowSize from "../components/hooks/useWindowSize";
import { FaArrowLeft } from "react-icons/fa6";

const ForgotPassword = () => {
    const title = "Восстановление пароля";
    const description = "";
    const windowSize = useWindowSize();
    const navigate = useNavigate();
    const { user, token } = useSelector(state => state.user);
    const [isSent, setIsSent] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [values, setValues] = useState({
        email: "",
    });

    useEffect(() => {
        if (user) {
            navigate("/");
        }
        return () => {
            setIsSent(false);
        }
    }, [user])

    const onSubmit = (event) => {
        event && event.preventDefault();
        setIsLoading(true);
        MainService.callApi({
            api: ApiService.forgotPassword,
            data: values.email,
            cb: response => {
                setIsSent(true);
            },
            _finally: () => {
                setIsLoading(false);
            }
        });
    }

    return (<>

        <Container fluid className="login p-4 pb-5">
            <HtmlHead title={title} description={description} />
            <div className="d-flex justify-content-between">
                <Link to="/" className="header-button text-nowrap back-button d-flex gap-1 align-items-center border-1">
                    <FaArrowLeft size={18} className="mt-1" />
                    <span>на главную</span>
                </Link>
            </div>
            <Row className="mt-5">
                <Col lg={6} className="mt-3 mt-lg-0">
                    <div className="border-dashed radius-50 p-4 pt-4 bg-white">
                        {
                            isSent ? <p className="title forgot-password-title">Запрос отправлен!</p> : <p className="title forgot-password-title">ВОССТАНОВЛЕНИЕ ПАРОЛЯ</p>
                        }
                        {
                            isSent ? <div>
                                <p className='mb-4 text-center text'>Мы отправили ссылку для сброса пароля на ваш адрес электронной почты. Проверьте свой почтовый ящик и перейдите по ссылке, чтобы сбросить пароль.</p>
                            </div>
                                : <form onSubmit={onSubmit} className="form">
                                    <div className="mb-4">
                                        <label htmlFor="email">Введите вашу почту</label>
                                        <input
                                            id="email"
                                            className="border-1 radius-20 p-3 w-100"
                                            value={values.email}
                                            type="email"
                                            onChange={(event) => setValues({ ...values, email: event.target.value })}
                                            required
                                        />
                                    </div>
                                    <div>
                                        <Button type="submit" variant="dark" className="radius-20 py-2 w-100" disabled={isLoading}>
                                            {isLoading ? "Отправка..." : "Отправить ссылку"}
                                        </Button>
                                    </div>
                                    <Link to="/login" className="link">Вернуться к входу</Link>
                                </form>
                        }

                    </div>
                </Col>
                <Col lg={6} className="mt-3 mt-lg-0">
                    <div className="radius-50 p-0 p-lg-4 pt-3 pt-lg-0 h-100">
                        <div className="text">
                            <p className="mb-4">
                                Введите свой email, и мы отправим вам ссылку для восстановления пароля.
                            </p>
                            <p className="mb-4">Если у вас нет доступа к указанному email, пожалуйста, обратитесь в службу поддержки:</p>
                            <p className="ms-4">
                                <span className="d-block"> • Почта: support@govorok-moscow.ru</span>
                                <span className="d-block"> • Телеграм: @govoroksupport</span>
                            </p>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
        <Marquee
            content={windowSize.width > 1024 ? ["логопед-дефектолог", "наталья смагина", "логопед-дефектолог", "наталья смагина"] : ["логопед-дефектолог", "Наталья Смагина"]}
            blockClassName="dark-bg"
        />
    </>
    );
};

export default ForgotPassword;
